module.exports = __webpack_public_path__ + "img/Cycling-Track.a7899fa6.png";